module.exports = __webpack_public_path__ + "img/二星高级大师@2x.9582a327.png";